import React from 'react';
import { Login } from 'react-admin';

import LoginForm from './LoginForm';

const LoginPage = () => <Login backgroundImage="https://source.unsplash.com/1600x900/?nature,water" loginForm={<LoginForm />} />;

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Framework/LoginPage.tsx